module.exports = __webpack_public_path__ + "img/264.6eb3392b.gif";